



























































































































import Vue from "vue";
import { axios } from "../../plugins";
// @ts-ignore
import CodeMirror from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/mode/yaml/yaml.js";
import { Form } from "element-ui";
// import "codemirror/mode/yaml-frontmatter/yaml-frontmatter.js";
export default Vue.extend({
  name: "CreateTemApp",
  props: {
    projectId: { type: String },
    appCode: { type: String }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isEdit: false,
      registryOptions: [] as any[],
      imageOptions: [] as any[],
      imageTagOptions: [] as any[],
      imageData: {
        imageName: ""
      },
      ruleForm: {
        componentName: "",
        description: "",
        repoName: "",
        chartName: "",
        chartVersion: "",
        secretName: "",
        version: "",
        values: ""
      },
      rules: {
        version: [{ required: true, type: "string" }],
        componentName: [
          { required: true, type: "string", pattern: /^(?!-)[a-z0-9-]*[^-]$/ }
        ],
        values: [{ required: true, type: "string" }]
      },
      codeEditor: null as any,
      previewEditor: null as any,
      Templete: "",
      TempleteOptions: {} as any
    };
  },
  mounted() {
    this.getRegistrys();
  },
  methods: {
    show(data: any) {
      if (data) {
        this.isEdit = true;
        // this.ruleForm = JSON.parse(JSON.stringify(data));
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
      this.$nextTick(() => {
        this.codeEditor = CodeMirror(document.getElementById("code"), {
          mode: "text/x-yaml",
          theme: "monokai"
        });
        this.codeEditor.on("change", (instance: any) => {
          this.ruleForm.values = instance.getValue();
        });
        this.previewEditor = CodeMirror(document.getElementById("preview"), {
          mode: "text/x-yaml",
          readOnly: true
        });
      });
    },
    // 请求仓库数据
    getRegistrys() {
      axios.get(`/secret/registry?projectId=${this.projectId}`).then(res => {
        this.registryOptions = res.data.data;
      });
    },
    // 请求镜像数据
    getImages(name: string) {
      this.imageData.imageName = "";
      this.ruleForm.chartVersion = "";

      axios
        .get(`/images/charts?projectId=${this.projectId}&registryName=${name}`)
        .then(res => {
          this.imageOptions = res.data.data;
        });
    },
    // 请求镜像版本
    getImageTag(name: string) {
      const [repoName, imageName] = name.split("/");
      this.ruleForm.repoName = repoName;
      this.ruleForm.chartName = imageName;
      this.ruleForm.chartVersion = "";
      axios
        .get(
          `/images/charts/tags?projectId=${this.projectId}&registryName=${this.ruleForm.secretName}&imageName=${imageName}&repoName=${repoName}`
        )
        .then(res => {
          this.imageTagOptions = res.data.data;
        });
    },
    setImageInfo(version: string) {
      const [repoName, imageName] = this.imageData.imageName.split("/");

      axios
        .get(
          `/images/charts/tags/detail?projectId=${this.projectId}&registryName=${this.ruleForm.secretName}&imageName=${imageName}&repoName=${repoName}&version=${version}`
        )
        .then(res => {
          this.codeEditor.setValue(res.data.data.files["values.yaml"]);
          this.previewEditor.setValue(res.data.data.files["values.yaml"]);
          this.TempleteOptions = res.data.data.files;
          this.Templete = "values.yaml";
        });
    },
    TempleteChange(key: string) {
      this.previewEditor.setValue(this.TempleteOptions[key]);
    },
    quit() {
      this.ruleForm = {
        componentName: "",
        description: "",
        repoName: "",
        chartName: "",
        chartVersion: "",
        secretName: "",
        version: "",
        values: ""
      };
      this.imageData = {
        imageName: ""
      };
      this.imageOptions = [] as any[];
      this.imageTagOptions = [] as any[];
      this.codeEditor = null;
      this.previewEditor = null;
      this.$refs.ruleForm && (this.$refs.ruleForm as Form).clearValidate();
      this.dialog = false;
      this.$emit("afterClose");
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    create() {
      axios
        .post(`/helm/${this.projectId}`, this.ruleForm)
        .then(() => {
          this.$message.success("组件创建成功！");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit() {
      axios
        .put(`/helm/${this.projectId}`, this.ruleForm)
        .then(() => {
          this.$message.success("组件编辑成功！");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
